
@if (enabled()) {
  <section data-testid="hero-banner" [attr.class]="'HeroBanner HeroBanner--' + bannerSize()" [style]="styles().container">
    <div class="container HeroBanner__wrapper">
      <div class="HeroBanner__content" [style]="styles().content">
        @let i18nMainText = i18n.get(mainText());
        @let i18nSubText = i18n.get(subText());
        @if (i18nMainText) {
          <h2 class="HeroBanner__heading" data-testid="hero-banner-heading" [class]="mainTextSize()">{{i18nMainText}}</h2>
        }
        @if (i18nSubText) {
          <h3 class="HeroBanner__subheading h6" data-testid="hero-banner-subheading">{{i18nSubText}}</h3>
        }
        <app-search
          class="HeroBanner__search"
        ></app-search>
        @if (quantity() > 0) {
          @if (categories$ | async; as categories) {
            <div class="HeroBanner__pills-wrapper">
              @if (categories.data) {
                <div class="HeroBanner__pills">
                  @for (item of categories.data; track item.category_id) {
                    <a
                      class="HeroBanner__pill"
                      data-testid="hero-banner-pill"
                      [attr.aria-label]="pillAriaLabel.replace('{category}', item.category)"
                      [style]="styles().quickFilters" [routerLink]="[SearchRoutePaths.CategoryFull.replace(':category', item.category)]"
                    >{{ item.category }}</a>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="HeroBanner__pills-wrapper">
              <div class="HeroBanner__pills">
                @for (item of [].constructor(+quantity()); track item){
                  <div class="HeroBanner__pill" [style]="styles().quickFilters">
                    <mat-spinner diameter="18"></mat-spinner>
                  </div>
                }
              </div>
            </div>
          }
        }
        @let i18nCtaText = i18n.get(ctaText());
        @if (i18nCtaText) {
          <app-button
            btn-medium
            btn-contained
            btn-primary
            [routerLink]="[RoutePaths.Search]"
            class="HeroBanner__cta"
            data-testid="hero-banner-cta"
            [styleOverrides]="styles().ctaText"
          >{{i18nCtaText}}</app-button>
        }
      </div>
    </div>
    @if (imageToggle() && !!imageSrcData()) {
      <img class="HeroBanner__image"
        aria-hidden="true"
        data-testid="hero-banner-image"
        [srcset]="imageSrcSet"
        [sizes]="imageSizes"
        [alt]="i18n.get(bannerAltText())"
        [style]="styles().bannerImage"
      >
      <div class="HeroBanner__overlay"></div>
    }
  </section>
}